export class TextUtility {

  static copyToClipboard(value: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  static findHashtags(text: string, withoutHash: boolean): string[] {
    let matches = text.split(' ').filter(v => v.startsWith('#'))
    if (!withoutHash) return matches
    else return matches.map(value => value.replace('#', ''))
  }

  static removeSpecialCharacters(text: string, keepSpaces: boolean = true): string {
    let regex = keepSpaces ? /[^a-zA-Z0-9\s]/g : /[^a-zA-Z0-9]/g
    return text.replace(regex, '')
  }

  static slugify(text: string | null): string {
    if (text == null) return "";

    return text
      .toString()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^-\p{L}\p{N}\u0980-\u09FF]+/gu, '')  // Keep Unicode letters, numbers, dashes, and Bengali characters
      .replace(/\-\-+/g, '-')         // Replace multiple dashes with a single dash
      .replace(/^-+/, '')             // Trim dashes from start
      .replace(/-+$/, '');            // Trim dashes from end
  }

  static codify(text: string | null): string {
    if (text == null) return ""
    return text.toString().toUpperCase()
      .replace(/\s+/g, '_')           // Replace spaces with _
      .replace(/[^\w\_]+/g, '')       // Remove all non-word chars
      .replace(/\_\_+/g, '_')         // Replace multiple _ with single _
      .replace(/^_+/, '')             // Trim _ from start of text
      .replace(/_+$/, '')             // Trim _ from end of text
  }

  static randomString(length: number): string {
    let result = ''
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength))
    }
    return result
  }

  static extractHashtags(text: string): string[] {
    const hashtagRegex = /#\w+/g;
    return text.match(hashtagRegex) || [];
  }

  static extractHashtagsWithoutSymbols(text: string): string[] {
    const hashtagRegex = /#(\w+)/g;
    return Array.from(text.matchAll(hashtagRegex), match => match[1]);
  }

  static extractSlug(segment: string, url: string): string | null {
    const segments = url.split('/');
    // Assuming the blog name is always the second segment after "/blog/"
    if (segments.length > 2 && segments[1] === segment) {
      return segments[2];
    }
    return null;
  }

  // static findHashtags2(searchText: string) {
  //   let regexp = /(\s|^)\#\w\w+\b/gm
  //   let result = searchText.match(regexp);
  //   if (result) {
  //     result = result.map(function (s) {
  //       return s.trim();
  //     });
  //     return result;
  //   } else {
  //     return false;
  //   }
  // }

}
